import React, { FC } from 'react';
import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { Stack, Typography } from '@mui/material';
import { getHtmlId, getTypeDescription, useNumberedNode } from '../../numbering';
import { capitalizeFirstLetter } from '../../../../../utils/string';
import styled from '@emotion/styled';
import { BlockNode } from '../BlockNode';
import { useModal } from '../../../../../dialogs/useModal';
import { ChartDialog, ChartDialogProps, ChartDialogResult } from '../../../charts/ChartDialog';
import { BlockNodeToolbar } from './BlockNodeToolbar';

const StyledChartFigure = styled.figure`
  & > * > * > figcaption {
    position: relative;
    margin: 10px 0;
    padding: 5px 10px;
    border: 1px solid #bdbdbd;
    width: fit-content;
    min-width: 400px;

    &:before {
      font-size: 12px;
      color: #666;
      position: absolute;
      top: -10px;
      background-color: white;
      content: 'Figurtekst';
    }
  }
`;

export const ChartFigureView: FC<NodeViewProps> = (props) => {
  const attrs = props.node.attrs;
  const node = useNumberedNode(attrs.id, props.editor);
  const chartNode = props.node.content.firstChild;
  const modal = useModal<ChartDialogProps, ChartDialogResult>({ data: { chartNode } });

  const openChartDialog = async () => {
    const result = await modal.open({ chartNode });
    if (result) {
      const { width, config } = result;
      const chartPos = props.getPos();
      if (chartPos === undefined) return;
      props.editor.view.dispatch(
        props.editor.view.state.tr.setNodeMarkup(chartPos + 1, undefined, {
          ...chartNode?.attrs,
          width,
          config,
        }),
      );
    }
  };

  return (
    <NodeViewWrapper className="react-component">
      {modal.isOpen && <ChartDialog {...modal} />}
      <BlockNode props={props}>
        <StyledChartFigure id={node ? getHtmlId(node) : ''}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6">
              {capitalizeFirstLetter(getTypeDescription('chartFigure'))} {node?.numbering}
            </Typography>
            {props.editor.isEditable && (
              <BlockNodeToolbar onEdit={openChartDialog} editTooltip="Rediger graf" onDelete={() => props.deleteNode()} deleteTooltip="Slett graf" />
            )}
          </Stack>
          <NodeViewContent className="content" as="div"></NodeViewContent>
        </StyledChartFigure>
      </BlockNode>
    </NodeViewWrapper>
  );
};
